import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { Form, Label } from 'semantic-ui-react';
import brnv from 'bank-routing-number-validator';
import PropTypes from 'prop-types';

const PaymentInformationCheck = ({ source, onChange, actions, banks, isWallet, showErrors }) => {
	const { accountType, routingNumber, accountNumber, accountNumberConfirmation, firstName, lastName } = source;

	const [routingValid, setRoutingValid] = useState(routingNumber === '' || routingNumber === null || (routingNumber !== '' && brnv.ABARoutingNumberIsValid(routingNumber)));

	const accountTypeOptions = [
		{ text: 'Checking', value: 1 },
		{ text: 'Savings', value: 2 }
	];

	const bankName = useMemo(() => (routingValid ? banks[routingNumber] : null), [banks, routingNumber, routingValid]);

	const onRoutingNumberChange = useCallback(
		(e, data) => {
			setRoutingValid(true);
			onChange(e, data);
		},
		[onChange]
	);

	const onRoutingNumberBlur = useCallback(() => {
		const { routingNumber } = source;

		const valid = routingNumber === '' || routingNumber === null || (routingNumber !== '' && brnv.ABARoutingNumberIsValid(routingNumber));
		setRoutingValid(valid);
	}, [source]);

	useEffect(() => {
		if (routingValid && !bankName && routingNumber && routingNumber.length === 9) {
			actions.getBankName(routingNumber);
		}
	}, [actions, bankName, routingNumber, routingValid]);

	return (
		<React.Fragment>
			<Form.Dropdown name='accountType' selection label='Account Type' placeholder='Account Type' options={accountTypeOptions} defaultValue={accountType} onChange={onChange} value={accountType} error={showErrors && !accountType} />
			<Form.Field>
				{isWallet && (
					<React.Fragment>
						<Form.Input name='firstName' label='First Name' placeholder='First Name' value={firstName || ''} onChange={onChange} error={showErrors && !firstName} />
						<Form.Input name='lastName' label='Last Name' placeholder='Last Name' value={lastName || ''} onChange={onChange} error={showErrors && !lastName} />
					</React.Fragment>
				)}

				<label>Routing # {bankName ? ' - ' + bankName : ''}</label>
				<Form.Input name='routingNumber' placeholder='Routing #' value={routingNumber || ''} onChange={onRoutingNumberChange} error={!routingValid || (showErrors && !routingNumber)} onBlur={onRoutingNumberBlur} type="number" />
				
				{!routingValid && (
					<Label pointing prompt color='red'>
						Incorrect number entered. Please check and re-enter to proceed with payment.
					</Label>
				)}
			</Form.Field>
			<Form.Input maxLength={17} name='accountNumber' label='Bank Account #' placeholder='Bank Account #' value={accountNumber || ''} onChange={onChange} error={showErrors && !accountNumber} type="number"/>
			<Form.Input maxLength={17} name='accountNumberConfirmation' label='Confirm Bank Account #' placeholder='Confirm Bank Account #' value={accountNumberConfirmation || ''} onChange={onChange} error={showErrors && (!accountNumberConfirmation || accountNumber !== accountNumberConfirmation)} type="number" />
		</React.Fragment>
	);
};

PaymentInformationCheck.propTypes = {
	source: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	banks: PropTypes.object.isRequired,
	loading: PropTypes.bool,
	actions: PropTypes.object.isRequired
};

export default PaymentInformationCheck;
